module.exports = __webpack_public_path__ + "img/otro_recepcionista.75263cec.png";